import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Search, MapPin, Calendar } from 'lucide-react';
import { Button } from './ui/Button';
const trips = [{
  id: 1,
  title: 'Everest Base Camp',
  image: 'https://images.unsplash.com/photo-1533130061792-649d45df8c2d?q=80&w=1978&auto=format&fit=crop',
  duration: '14 Days',
  difficulty: 'Hard',
  price: '$1,450',
  location: 'Nepal',
  link: 'https://project-everest-base-camp-trek-detail-page-148.magicpatterns.app/'
}, {
  id: 2,
  title: 'Annapurna Circuit',
  image: 'https://images.unsplash.com/photo-1548588627-f978862b85e1?q=80&w=2072&auto=format&fit=crop',
  duration: '16 Days',
  difficulty: 'Moderate',
  price: '$1,250',
  location: 'Nepal',
  link: '#'
}, {
  id: 3,
  title: 'Langtang Valley',
  image: 'https://images.unsplash.com/photo-1623492701902-47d3be136e96?q=80&w=2070&auto=format&fit=crop',
  duration: '9 Days',
  difficulty: 'Moderate',
  price: '$950',
  location: 'Nepal',
  link: '#'
}, {
  id: 4,
  title: 'Lhasa Express',
  image: 'https://images.unsplash.com/photo-1526716173434-a1b560f2065d?q=80&w=2070&auto=format&fit=crop',
  duration: '8 Days',
  difficulty: 'Moderate',
  price: '$1,850',
  location: 'Tibet',
  link: '#'
}, {
  id: 5,
  title: 'Manaslu Circuit',
  image: 'https://images.unsplash.com/photo-1544735716-392fe2489ffa?q=80&w=2071&auto=format&fit=crop',
  duration: '16 Days',
  difficulty: 'Hard',
  price: '$1,650',
  location: 'Nepal',
  link: '#'
}, {
  id: 6,
  title: 'Gokyo Lakes',
  image: 'https://images.unsplash.com/photo-1605640840605-14ac1855827b?q=80&w=1933&auto=format&fit=crop',
  duration: '13 Days',
  difficulty: 'Hard',
  price: '$1,390',
  location: 'Nepal',
  link: '#'
}];
interface SearchOverlayProps {
  isOpen: boolean;
  onClose: () => void;
}
export function SearchOverlay({
  isOpen,
  onClose
}: SearchOverlayProps) {
  const [searchQuery, setSearchQuery] = useState('');
  const [showResults, setShowResults] = useState(false);
  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    setShowResults(true);
  };
  const filteredTrips = trips.filter(trip => {
    if (!searchQuery.trim()) return true;
    const query = searchQuery.toLowerCase();
    return trip.title.toLowerCase().includes(query) || trip.location.toLowerCase().includes(query) || trip.difficulty.toLowerCase().includes(query) || trip.duration.toLowerCase().includes(query);
  });
  return <AnimatePresence data-id="element-311">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} className="fixed inset-0 z-50 overflow-y-auto" data-id="element-312">
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 bg-gray-900/95 backdrop-blur-md" onClick={onClose} data-id="element-313" />

          {/* Content */}
          <div className="relative min-h-screen flex flex-col" data-id="element-314">
            {/* Close Button */}
            <div className="absolute top-6 right-6 z-10" data-id="element-315">
              <button onClick={onClose} className="p-3 bg-white/10 hover:bg-white/20 rounded-full text-white transition-colors" data-id="element-316">
                <X size={24} data-id="element-317" />
              </button>
            </div>

            {/* Search Form */}
            <div className="flex-shrink-0 pt-24 pb-12" data-id="element-318">
              <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-319">
                <motion.div initial={{
              opacity: 0,
              y: -20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: 0.1
            }} className="text-center mb-8" data-id="element-320">
                  <h2 className="text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-321">
                    Find Your Perfect Trip
                  </h2>
                  <p className="text-gray-300 text-lg" data-id="element-322">
                    Search through our collection of Himalayan adventures
                  </p>
                </motion.div>

                <motion.form initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: 0.2
            }} onSubmit={handleSearch} className="bg-white rounded-2xl shadow-2xl p-8 md:p-12" data-id="element-323">
                  {/* Search Input with Underline */}
                  <div className="mb-8" data-id="element-324">
                    <div className="relative" data-id="element-325">
                      <Search className="absolute left-0 top-1/2 -translate-y-1/2 text-gray-400" size={28} data-id="element-326" />
                      <input type="text" placeholder="Search trips by name, location, or difficulty..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full pl-12 pr-4 py-4 border-0 border-b-2 border-gray-300 focus:outline-none focus:border-[#0066FF] text-xl bg-transparent transition-colors placeholder:text-gray-400" autoFocus data-id="element-327" />
                    </div>
                  </div>

                  {/* Search Button */}
                  <Button type="submit" variant="primary" size="lg" className="w-full justify-center text-lg" data-id="element-328">
                    <Search size={20} className="mr-2" data-id="element-329" />
                    Search Trips
                  </Button>
                </motion.form>
              </div>
            </div>

            {/* Results */}
            <AnimatePresence data-id="element-330">
              {showResults && <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: 20
          }} transition={{
            delay: 0.3
          }} className="flex-1 bg-white" data-id="element-331">
                  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-332">
                    <div className="mb-8" data-id="element-333">
                      <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-334">
                        Search Results
                      </h3>
                      <p className="text-gray-600" data-id="element-335">
                        Found {filteredTrips.length}{' '}
                        {filteredTrips.length === 1 ? 'trip' : 'trips'}
                        {searchQuery && ` matching "${searchQuery}"`}
                      </p>
                    </div>

                    {filteredTrips.length > 0 ? <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-336">
                        {filteredTrips.map((trip, index) => <motion.a key={trip.id} href={trip.link} target={trip.link.startsWith('http') ? '_blank' : '_self'} rel={trip.link.startsWith('http') ? 'noopener noreferrer' : undefined} initial={{
                  opacity: 0,
                  y: 20
                }} animate={{
                  opacity: 1,
                  y: 0
                }} transition={{
                  delay: index * 0.1
                }} className="group bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all border border-gray-200" data-id="element-337">
                            <div className="relative h-48 overflow-hidden" data-id="element-338">
                              <img src={trip.image} alt={trip.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-339" />
                              <div className="absolute top-3 right-3 bg-white px-3 py-1 rounded-full text-xs font-semibold" data-id="element-340">
                                {trip.difficulty}
                              </div>
                            </div>
                            <div className="p-5" data-id="element-341">
                              <h4 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-[#0066FF] transition-colors" data-id="element-342">
                                {trip.title}
                              </h4>
                              <div className="flex items-center gap-3 text-sm text-gray-600 mb-3" data-id="element-343">
                                <span className="flex items-center gap-1" data-id="element-344">
                                  <MapPin size={14} data-id="element-345" />
                                  {trip.location}
                                </span>
                                <span className="flex items-center gap-1" data-id="element-346">
                                  <Calendar size={14} data-id="element-347" />
                                  {trip.duration}
                                </span>
                              </div>
                              <div className="flex items-center justify-between pt-3 border-t border-gray-100" data-id="element-348">
                                <span className="text-2xl font-bold text-[#0066FF]" data-id="element-349">
                                  {trip.price}
                                </span>
                                <span className="text-[#0066FF] font-medium" data-id="element-350">
                                  View Details →
                                </span>
                              </div>
                            </div>
                          </motion.a>)}
                      </div> : <div className="text-center py-16" data-id="element-351">
                        <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-352">
                          <Search size={32} className="text-gray-400" data-id="element-353" />
                        </div>
                        <h4 className="text-xl font-bold text-gray-900 mb-2" data-id="element-354">
                          No trips found
                        </h4>
                        <p className="text-gray-600" data-id="element-355">
                          Try searching with different keywords
                        </p>
                      </div>}
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>
        </motion.div>}
    </AnimatePresence>;
}